import { useContext } from 'react';

import AppContext from '@lib/store/context';

export const useStore = () => useContext(AppContext);
